// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__332BQ","search":"Settings_search__1vqQH","filter":"Settings_filter__2Duku"};